module.exports = __webpack_public_path__ + "img/undraw_authentication.8e989386.svg";